import { render, staticRenderFns } from "./Backend.vue?vue&type=template&id=7b31caf8"
import script from "./Backend.vue?vue&type=script&lang=js"
export * from "./Backend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b31caf8')) {
      api.createRecord('7b31caf8', component.options)
    } else {
      api.reload('7b31caf8', component.options)
    }
    module.hot.accept("./Backend.vue?vue&type=template&id=7b31caf8", function () {
      api.rerender('7b31caf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/variations/Backend.vue"
export default component.exports